// extracted by mini-css-extract-plugin
export default {"mainContainer":"DialogMessage_mainContainer__EEGWG"};